import React from "react";
import "./TagStatus.css";
import cx from "classnames";

const TEXT_STATUS = {
  Registered: "Terdaftar",
  Confirmed: "Terkonfirmasi",
  "Checked-in": "Check In",
  "On-process": "Diproses",
  Done: "Selesai",
  Passed: "Antrian Terlewat",
  Canceled: "Dibatalkan",
  Emergency: "Darurat",
  "Not Responding": "Tidak Merespon",
};

const TagStatus = ({ text }) => {
  return (
    <div className="tag-status-container">
      <div
        className={cx("tag-status-dot", {
          "tag-status-green": ["on-process", "done"].includes(
            text?.toLowerCase()
          ),
          "tag-status-blue": text?.toLowerCase() === "checked-in",
          "tag-status-light-blue": text?.toLowerCase() === "confirmed",
          "tag-status-yellow": text?.toLowerCase() === "registered",
          "tag-status-red": [
            "not responding",
            "passed",
            "antrian terlewat",
          ].includes(text?.toLowerCase()),
          "tag-status-emergency": text?.toLowerCase() === "emergency",
        })}
      />
      <span className="tag-status-text">
        {/* {text === "Passed" ? "antrian terlewat" : text} */}
        {TEXT_STATUS[text]}
      </span>
    </div>
  );
};

export default TagStatus;
